// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"0fa981559a134048e34a","293":"2b64b6e51795b30dea1b","522":"eb142279ca9215c8de92"}[chunkId] + ".js";
};